<template>
    <div class="sd-photo">
        <sheet :show.sync="show">
            <!-- <sd-button class="photo-button" @click.native="take()">Take a picture</sd-button> -->
            <sd-button class="photo-button" @click.native="choose()">{{$t('text.choose_picture')}}</sd-button>
        </sheet>

        <input style="display: none;" ref="input" type="file" accept="image/*" @change="inputChange" />
    </div>
</template>

<script>
import sheet from "./sheet.vue";
import sdButton from "./button.vue";

export default {
    name: "sd-photo",
    components: { sheet, sdButton },
    props: {
        getFile: false
    },
    data() {
        return {
            show: true
        }
    },
    watch: {
        show(val) {
            if(!val) {
                this.close();
            }
        }
    },
    methods: {
        take() {

        },

        choose() {
            this.$refs.input.click();
        },

        inputChange() {
            let inputDiv = this.$refs.input;
            let file = inputDiv.files[0];
            if(this.getFile) return this.$emit('choose', file)
            let formData = new FormData();
            formData.append("file",file);
            // formData.append("img_path","h5_img");
            this.$apis.common.uploadImg(formData).then(res => {
                inputDiv.value = null;
                // this.$utils.message(this, "上传成功");
                this.$emit('success', res)
                this.close();
            })
        },

        close() {
            this.$emit("close");
            this.$emit('update:show', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.sd-photo {
    /deep/ {
        .project-sheet {
            background-color: white;
            border-radius: 3.46667vw 3.46667vw 0px 0px;
        }
    }
        
    .photo-button {
        height: 52px;
        margin: 16px;
        width: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/photo.vue